// Central app configuration + feature flags.
// Aligned with ADR-0009 (mobile-first, portable) and ADR-0007 (ATLAS capability classes).
// This file is the SINGLE source of truth for runtime config on the client.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  throw new Error("REACT_APP_BACKEND_URL is not defined");
}

export const config = Object.freeze({
  env: process.env.NODE_ENV || "development",
  apiBaseUrl: `${BACKEND_URL}/api`,
  backendUrl: BACKEND_URL,
  appName: "ROCAFUERTE GO",
  brand: "ROCAFUERTE — Bienes Raíces",
  locale: "es-MX",
  currency: "MXN",
  supportEmail: "contacto@rocafuertebienesraices.com",
  supportPhone: "+52 811 130 5125",
  debug: process.env.REACT_APP_DEBUG === "true",
  mockApi: process.env.REACT_APP_MOCK_API === "true",
});

// Feature flags. Off by default; each phase flips its own flags.
// Adding a flag here does NOT enable a feature. The consuming code must check it.
export const features = Object.freeze({
  // Foundation (Phase 1)
  errorBoundary: true,
  mobileNav: true,

  // Multi-role & auth (Phase 1 · Fase 1)
  multiRole: false,
  emailVerification: false,
  passwordReset: true,

  // Core Property Management (Phase 2)
  videoUpload: false,
  propertyStates: false,
  propertySlug: false,
  viewCounter: false,

  // Buyer Experience (Phase 2 · Fase 3)
  savedSearches: false,
  emailAlerts: false,
  advancedFilters: true,
  recentlyViewed: false,
  scheduleViewing: false,

  // Seller Experience (Phase 4)
  agencyAccounts: false,
  advisorAnalytics: false,
  leadsPipeline: false,
  verificationBadge: false,

  // ATLAS (Phase 5) — Level 1
  atlasBusinessDashboard: false,
  // ATLAS Level 2 — Property Workflow
  atlasPrepare: false,
  atlasPublish: false,
  atlasPromote: false,
  atlasManage: false,
  atlasOptimize: false,
  // ATLAS Buyer Journey
  atlasConversationalSearch: true,

  // Marketing (Phases 6-7)
  flyerGenerator: false,
  socialWhatsApp: true,
  socialCopyLink: true,
  socialFacebook: true,
  socialInstagram: false,
});

export const isEnabled = (flag) => Boolean(features[flag]);

// ATLAS Capability Class placeholders (per ADR-0007 section 3).
// Concrete model mapping lives server-side in atlas.config.
// Frontend only cares about the CLASS name; never the concrete model.
export const atlasCapabilityClasses = Object.freeze({
  PremiumWritingModel: "PremiumWritingModel",
  FastStructuredModel: "FastStructuredModel",
  CommercialAnalysisModel: "CommercialAnalysisModel",
  ReasoningModel: "ReasoningModel",
});
